import { render } from "./InternalDesign.vue?vue&type=template&id=0f40ccd2&scoped=true"
import script from "./InternalDesign.vue?vue&type=script&lang=js"
export * from "./InternalDesign.vue?vue&type=script&lang=js"

import "./InternalDesign.vue?vue&type=style&index=0&id=0f40ccd2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f40ccd2"]])

export default __exports__